import { MessagesSquare, Crown, BadgeCheck, ShieldCheck, Languages } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

const ICONS = [MessagesSquare, Crown, BadgeCheck, ShieldCheck, Languages];
const SPANS = [
  "md:col-span-4 md:row-span-2",
  "md:col-span-2",
  "md:col-span-2",
  "md:col-span-3",
  "md:col-span-3",
];

const ChatPreview = ({ lines }) => (
  <div className="mt-8 space-y-3">
    {lines.map((l, i) => (
      <motion.div
        key={l}
        initial={{ opacity: 0, x: i % 2 ? 20 : -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ delay: 0.3 + i * 0.25, duration: 0.6 }}
        className={`max-w-[80%] rounded-2xl px-4 py-2.5 text-sm ${i % 2 ? "ml-auto bg-violet-500/25 text-white rounded-br-sm" : "bg-white/10 text-slate-100 rounded-bl-sm"}`}
      >
        {l}
      </motion.div>
    ))}
  </div>
);

export const WhyJoin = () => {
  const { t } = useLang();
  return (
    <section id="why" className="relative py-28 md:py-40" data-testid="why-section">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <Reveal><Overline>{t.why.over}</Overline></Reveal>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-6 md:auto-rows-[minmax(230px,auto)] gap-4">
          {t.why.cards.map((c, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.06} className={`${SPANS[i]}`}>
                <div data-testid={`why-card-${i}`} className={`bento-card group h-full rounded-[1.75rem] p-7 md:p-8 flex flex-col ${i === 0 ? "bento-hero" : ""}`}>
                  <div className="flex items-center justify-between">
                    <span className="grid place-items-center w-11 h-11 rounded-xl bg-white/[0.06] border border-white/10 text-sky-300 transition-transform duration-500 group-hover:-rotate-12 group-hover:scale-110">
                      <Icon className="w-5 h-5" />
                    </span>
                    <span className="font-mono text-xs text-slate-400">0{i + 1}</span>
                  </div>
                  <h3 className={`mt-auto pt-10 font-display font-bold text-white tracking-tight ${i === 0 ? "text-3xl md:text-4xl" : "text-xl md:text-2xl"}`}>{c.t}</h3>
                  <p className="mt-3 text-sm md:text-base text-slate-300 leading-relaxed">{c.d}</p>
                  {i === 0 && <ChatPreview lines={t.why.chatPreview} />}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
